/**
 * v3 guided tours — /v3/me/tours (the signed-in person's progress) and the
 * admin reset under /v3/admin/users/{userId}/tours. Bill 2026-10-07: role
 * tours "the first time you open a new app". Tour content lives in the apps.
 */

import type { RequestOptions } from '@retail-ops/shared-types';
import type { ApiHttpClient } from '../http.js';

export type TourStatus = 'completed' | 'dismissed';

export interface TourProgressRow {
  tourId: string;
  version: number;
  status: TourStatus;
  lastStep: number;
  updatedAt: string;
}

export interface MyToursResponse {
  success: boolean;
  data: { enabled: boolean; progress: ReadonlyArray<TourProgressRow> };
}

export class ToursApi {
  public constructor(private readonly http: ApiHttpClient) {}

  /** Tours switch (SystemSettings tours.enabled) + what this person has finished or closed. */
  public mine(opts?: RequestOptions): Promise<MyToursResponse> {
    return this.http.get<MyToursResponse>('/v3/me/tours', { ...opts });
  }

  /** Record that the signed-in person finished or closed a tour at this version. */
  public record(tourId: string, body: { version: number; status: TourStatus; lastStep: number }, opts?: RequestOptions): Promise<{ success: boolean }> {
    return this.http.put<{ success: boolean }>(`/v3/me/tours/${encodeURIComponent(tourId)}`, { ...opts, body });
  }

  /** Admin: one person's tour progress. */
  public forUser(userId: number, opts?: RequestOptions): Promise<{ success: boolean; data: ReadonlyArray<TourProgressRow> }> {
    return this.http.get(`/v3/admin/users/${userId}/tours`, { ...opts });
  }

  /** Admin: reset - every tour shows again on that person's next open. */
  public resetForUser(userId: number, opts?: RequestOptions): Promise<{ success: boolean; removed: number }> {
    return this.http.del(`/v3/admin/users/${userId}/tours`, { ...opts });
  }
}
